export default "__VITE_PUBLIC_ASSET__50d967e8__"